// src/pages/Profile.jsx

import React, { useState, useEffect } from "react";
import { FaStripe, FaSquare } from "react-icons/fa6";
import { MdOutlineLogout, MdOutlineCheckCircle } from "react-icons/md";
import axios from "axios";
import API_BASE_URL from "config/api";
import StripeSection from "./components/payment/StripeSection";
import SquareSection from "./components/payment/SquareSection";
import ProfileInfo from "./components/profileinfo/profileinfo"; // ✅ import path (no extension needed)

export default function Profile() {
  const [isStripeConnected, setStripeConnected] = useState(false);
  const [isSquareConnected, setSquareConnected] = useState(false);
  const [loading, setLoading] = useState(false);

  // ✅ Stripe + Square 계정 연결 상태 fetch
  useEffect(() => {
    const fetchConnections = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (!token) return;

        setLoading(true);
        const [stripeRes, squareRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/payments/stripe/account`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${API_BASE_URL}/api/payments/square/account`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setStripeConnected(stripeRes.data.connected || false);
        setSquareConnected(squareRes.data.connected || false);
      } catch (error) {
        console.error("Failed to fetch connections:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchConnections();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white px-8 pt-8 pb-10 space-y-10">
      {/* 🧍 Profile Info */}
      {/* <div className="bg-neutral-900 rounded-2xl border border-neutral-800 p-6 shadow-lg flex flex-col md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-2xl font-semibold mb-2">Your Profile</h1>
          <p className="text-gray-400 text-sm mb-4">
            Manage your connected accounts and business integrations.
          </p>
          <div className="space-y-1 text-gray-300">
            <p>
              <span className="text-gray-500 mr-2">Email:</span> user@chisquare.io
            </p>
            <p>
              <span className="text-gray-500 mr-2">Joined:</span> March 2024
            </p>
            <p>
              <span className="text-gray-500 mr-2">Role:</span> Admin
            </p>
          </div>
        </div>
        <div className="mt-6 md:mt-0">
          <button className="bg-yellow-400 hover:bg-yellow-300 text-black px-4 py-2 rounded-md font-medium">
            Edit Profile
          </button>
        </div>
      </div> */}
      <ProfileInfo />
      {/* 💳 Payment Connections */}
      <div className="bg-neutral-900 rounded-2xl border border-neutral-800 p-6 shadow-lg">
        <h2 className="text-xl font-semibold mb-6">Payment Connections</h2>
        <StripeSection />
        <SquareSection />
        
      </div>

      {/* 🔔 Notifications */}
      <div className="bg-neutral-900 rounded-2xl border border-neutral-800 p-6 shadow-lg">
        <h2 className="text-xl font-semibold mb-4">Notifications</h2>
        <p className="text-gray-400 text-sm mb-4">
          Manage your email alerts and integration updates.
        </p>
        <div className="space-y-3">
          <label className="flex items-center justify-between">
            <span>Email notifications for new sales</span>
            <input type="checkbox" defaultChecked className="accent-yellow-400" />
          </label>
          <label className="flex items-center justify-between">
            <span>Alert when integration fails</span>
            <input type="checkbox" className="accent-yellow-400" />
          </label>
          <label className="flex items-center justify-between">
            <span>Weekly performance summary</span>
            <input type="checkbox" className="accent-yellow-400" />
          </label>
        </div>
      </div>
    </div>
  );
}